import React from 'react'
import defaultFergusCompanyLogo from './no_company_image_small.png'

export default class FgCompanyLogo extends React.Component {
    static defaultProps = { style: {}, failedImageStyle: {} }
    constructor(props) {
        super(props)
        this.state = {
            failed: false,
        }
    }

    handleError() {
        this.setState({
            failed: true,
        })
    }

    render() {
        const { failed } = this.state

        const imageSrc = failed
            ? defaultFergusCompanyLogo
            : `https://fergusapp.com/index.php/ext/company_logo/${this.props.fergusId}`

        return (
            <img
                className="fg-company-logo"
                onError={this.handleError.bind(this)}
                src={imageSrc}
            ></img>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/clients/FgCompanyLogo.js